import { j as e } from "../../jsx-runtime-82a9ddf6.js";
import { cva as t } from "../../lib/cn.js";
const i = t("absolute rounded-full w-[9px] h-[9px] ease-[cubic-bezier(0, 1, 1, 0)]", {
  variants: {
    variant: {
      black: "bg-slate-900",
      purple: "bg-purple-600",
      white: "bg-white",
      secondary: "dark:bg-white bg-slate-900",
      primary: "bg-white dark:bg-slate-900"
    }
  },
  defaultVariants: {
    variant: "white"
  }
}), n = (s) => {
  const a = i(s);
  return /* @__PURE__ */ e.jsxs("div", { className: "flex relative w-[50px] h-[30px] items-center justify-center", children: [
    /* @__PURE__ */ e.jsx("div", { className: `animate-loader1 left-[5px] ${a} ` }),
    /* @__PURE__ */ e.jsx("div", { className: `animate-loader2 left-[5px] ${a} ` }),
    /* @__PURE__ */ e.jsx("div", { className: `animate-loader2 left-[20px] ${a} ` }),
    /* @__PURE__ */ e.jsx("div", { className: `animate-loader3 left-[35px] ${a} ` })
  ] });
};
export {
  n as Spin
};
